export const stringToBoolean = (value: string | null): boolean => {
  return value !== null && (value === 'true' || value === '1');
};
